import { RootState } from '../redux';

export const selectAccountsEntityCount = (state: RootState) => {
  return state.accountsEntityCount;
};
